/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionOfferDescription
 */
export interface SubscriptionOfferDescription {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionOfferDescription
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionOfferDescription
     */
    price: string;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionOfferDescription
     */
    validFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionOfferDescription
     */
    validUntil?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionOfferDescription
     */
    disabled: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SubscriptionOfferDescription
     */
    otherRules: { [key: string]: string; };
}

/**
 * Check if a given object implements the SubscriptionOfferDescription interface.
 */
export function instanceOfSubscriptionOfferDescription(value: object): value is SubscriptionOfferDescription {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('disabled' in value) || value['disabled'] === undefined) return false;
    if (!('otherRules' in value) || value['otherRules'] === undefined) return false;
    return true;
}

export function SubscriptionOfferDescriptionFromJSON(json: any): SubscriptionOfferDescription {
    return SubscriptionOfferDescriptionFromJSONTyped(json, false);
}

export function SubscriptionOfferDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionOfferDescription {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'price': json['price'],
        'validFrom': json['validFrom'] == null ? undefined : (new Date(json['validFrom'])),
        'validUntil': json['validUntil'] == null ? undefined : (new Date(json['validUntil'])),
        'disabled': json['disabled'],
        'otherRules': json['otherRules'],
    };
}

export function SubscriptionOfferDescriptionToJSON(json: any): SubscriptionOfferDescription {
    return SubscriptionOfferDescriptionToJSONTyped(json, false);
}

export function SubscriptionOfferDescriptionToJSONTyped(value?: SubscriptionOfferDescription | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'price': value['price'],
        'validFrom': value['validFrom'] == null ? undefined : ((value['validFrom']).toISOString()),
        'validUntil': value['validUntil'] == null ? undefined : ((value['validUntil']).toISOString()),
        'disabled': value['disabled'],
        'otherRules': value['otherRules'],
    };
}

